import React from 'react';

// The floating bottom-right "+" (owner 2026-08-27): every list module's create action lives in
// this ONE identical button — byte-for-byte the style Petty Cash / Taken-Return already had —
// replacing the assorted toolbar "New …" buttons. Keep it identical everywhere.
// Calem 2026-09-27 (Bugify #7568b3b5: "match the button color inside pages' top menu bubble"): only its colour differs —
// `color` is the page's top-menu button colour, tabColor(<tab key>) from src/tabPalette.ts. A page with no top-menu
// button passes none and keeps the app's accent.
export default function Fab({ onClick, title, color }: { onClick: () => void; title: string; color?: string }) {
  return (
    <button onClick={onClick} title={title} style={{ position: 'fixed', right: 24, bottom: 24, width: 52, height: 52, borderRadius: '50%', border: 'none', background: color || 'var(--accent)', color: '#fff', cursor: 'pointer', boxShadow: 'var(--shadow-md)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
      <i className="ti ti-plus" style={{ fontSize: 24 }} aria-hidden />
    </button>
  );
}
